import { useQuery } from '@tanstack/react-query';
import { getTeams } from '@fe-learner-common/api/queries/teams';
import { TTeams } from '@fe-learner-common/api/schemas/teams';
import { useConfigContext } from '@fe-core/context';

export const QUERY_KEY = 'teams';

const queryFunction = (apiUrl: string) => getTeams(apiUrl);

export const useTeams = (enabled?: boolean | undefined) => {
  const { config } = useConfigContext();

  if (!config?.apiUrls?.aleweb) {
    throw new Error('Missing API URL for aleweb');
  }

  const { data, error, ...rest } = useQuery<TTeams, Error>({
    queryKey: [QUERY_KEY],
    queryFn: () => queryFunction(config.apiUrls.aleweb as string),
    retry: false,
    staleTime: Infinity,
    enabled: enabled,
  });

  return {
    data,
    error,
    ...rest,
  };
};
